import { render } from "./EditBlock.vue?vue&type=template&id=e32665e2&scoped=true"
import script from "./EditBlock.vue?vue&type=script&lang=js"
export * from "./EditBlock.vue?vue&type=script&lang=js"

import "./EditBlock.vue?vue&type=style&index=0&id=e32665e2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e32665e2"

export default script